import React from 'react';
var DropdownSkeleton = function () { return (React.createElement("button", { className: "btn skeleton-line skeleton-h-xl skeleton-w-lg" })); };
export default React.memo(DropdownSkeleton);
